<template>
  <span v-if="this.$store.getters['limits/isLoadingOperatorsForSelect']">
    <i class="fas fa-spinner fa-pulse" v-if="this.$store.getters['limits/isLoadingOperatorsForSelect']"></i>{{ this.format }}
  </span>
  <span v-else>
    {{ this.format }}
  </span>
</template>

<script>
export default {
  props: [
    'value',
  ],
  computed: {
    format() {
      if (this.$store.getters['isShowDebugTools']) {
        return this.value;
      }

      if (this.$store.getters['limits/operatorsForSelect']) {
        const operator = this.$store.getters['limits/operatorsForSelect'].find(operator => operator.value === this.value);

        return operator ? operator.label : '';
      }

      return this.value;
    },
  },
  mounted() {
    if (!this.$store.getters['limits/isLoadedOperatorsForSelect']) {
      this.$store.dispatch('limits/loadOperatorsForSelect');
    }
  },
}
</script>
